export default __webpack_public_path__ + "static/media/004-clamp.8cc39b07.svg";